import styled from "styled-components";
import Btn from "../shared/button/Btn";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  margin-bottom: 18px;
  padding: 12px 14px;
  border: 1px solid ${({theme}) => theme.mainBorderColor};
  border-radius: 10px;
  background: ${({theme}) => theme.secondaryBgColor};
  color: ${({theme}) => theme.mainTextColor};

  .selection-info,
  .selection-controls {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .selection-count {
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-xl);
  }

  .text-button {
    padding: 0;
    border: 0;
    background: transparent;
    color: var(--color-main);
    font-size: 13px;
    font-weight: var(--font-weight-lg);
    cursor: pointer;
  }

  @media (max-width: 760px) {
    align-items: stretch;
    flex-direction: column;

    .selection-info {
      align-items: flex-start;
      flex-direction: column;
    }

    .selection-controls,
    .selection-controls button {
      width: 100%;
    }
  }
`;

const ShipmentBulkActions = ({selectedCount, allPageSelected, onClear, onSelectAll, onComplete}) => (
  <Container>
    <div className="selection-info">
      <span className="selection-count">
        {allPageSelected ? "Sayfadakilerin tümü seçili" : `${selectedCount} sevkiyat seçili`}
      </span>
      <button type="button" className="text-button" onClick={onClear}>Seçimleri kaldır</button>
      {!allPageSelected && <button type="button" className="text-button" onClick={onSelectAll}>Tümünü seç</button>}
    </div>
    <div className="selection-controls">
      <Btn width="230px" padding="0 18px" bgColor="#E85446" borderColor="transparent" color="#fff" handleClick={onComplete}>
        Seçili Sevkiyatları Tamamla
      </Btn>
    </div>
  </Container>
);

export default ShipmentBulkActions;
